import { useEffect, useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Reveal } from '@/components/Reveal';

export default function DashboardPreview() {
  const { t } = useLanguage();
  const [clock, setClock] = useState('00:32');
  useEffect(() => {
    const ck = setInterval(() => setClock(new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })), 30000);
    return () => clearInterval(ck);
  }, []);
  return (
    <Reveal>
      <div className="relative mx-auto max-w-5xl" data-testid="dashboard-preview">
        <div className="overflow-hidden rounded-[2rem] border border-brand-line bg-white shadow-[0_60px_120px_-40px_rgba(15,23,42,0.4)]" dir="ltr">
          <div className="flex items-center gap-3 border-b border-brand-line bg-brand-paper px-5 py-3.5">
            <span className="flex gap-1.5">
              <span className="h-3 w-3 rounded-full bg-brand-crimson/70" />
              <span className="h-3 w-3 rounded-full bg-brand-amber/70" />
              <span className="h-3 w-3 rounded-full bg-brand-emerald/70" />
            </span>
            <span className="mx-auto flex items-center gap-2 rounded-full border border-brand-line bg-white px-4 py-1.5 font-mono text-[11px] font-semibold text-brand-steel">
              {t('dashboard.url')}
            </span>
            <span className="w-14" />
          </div>
          <img src={t('dashboard.img')} alt="WiyakGPS platform dashboard" className="h-auto w-full" data-testid="dashboard-preview-image" loading="lazy" />
        </div>

        <div className="absolute -top-5 end-6 flex items-center gap-2 rounded-2xl bg-brand-ink/90 px-4 py-3 shadow-xl glass" data-testid="preview-clock-chip">
          <span className="relative flex h-2 w-2">
            <span className="pulse-ring absolute inline-flex h-full w-full rounded-full bg-brand-crimson" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-crimson" />
          </span>
          <span className="font-mono text-sm font-bold text-white" dir="ltr">{clock}</span>
          <span className="font-mono text-[9px] uppercase tracking-widest text-brand-dim">{t('hero.live')}</span>
        </div>
      </div>
    </Reveal>
  );
}
